import styled from "styled-components";

const ListContent = styled.div`
    cursor: pointer;
    color: var(--full-color);
    display: flex;
    font-size: 16px;
    align-items: center;
    padding-right: 24px;
`;

export { ListContent };
